"use client"

import { useToast } from "@/components/ui/toast"

export function Toaster() {
  // The ToastViewport is already included in the ToastProvider
  // so we don't need to render anything here
  return null
}